<template>
	<div class="cnt-exams">
		<b>Adicionar Exames</b>
		<div class="well well-sm">
			<div class="header">
				<div class="row">
					<div class="col-sm-10">
						<drop-draw
							:asset="listExams"
							cod="id"
							title="label"
							@change="send"
							v-model="selecteds"
							placeholder="Exames"
						/>
					</div>
					<div class="col-sm-2">
						<button class="btn btn-primary btn-block">
							<i class="fa fa-plus"></i>
						</button>
					</div>
				</div>
			</div>
		</div>
		<b>Ralaçõa de exames</b>
		<div class="well well-sm bg-white no-padding">
			<table class="table table-striped no-margin">
				<thead>
					<tr>
						<th>Bloco</th>
						<th>Exame</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(exam, index) in modelExams" :key="index">
						<td>{{ getTextBloco(exam) }}</td>
						<td>{{ getTextExam(exam) }}</td>
						<td>
							<button
								@click="remove(exam)"
								class="btn btn-danger btn-block btn-xs"
							>
								<i class="fa fa-trash"></i>
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>
<script>
	import dropDraw from 'app/drop-draw';
	export default {
		inject: ['assets'],
		props: ['value'],
		components: { dropDraw },
		data() {
			return {
				selecteds: [],
			};
		},
		methods: {
			remove(exam) {
				let index = this.modelExams.indexOf(exam);
				this.modelExams.splice(index, 1);
			},
			send() {
				this.selecteds.forEach((item) => {
					if (this.modelExams.indexOf(item) == -1) {
						this.modelExams.push(item);
					}
				});
				this.selecteds = [];
			},
			getTextBloco(id) {
				id = id.split('.')[0];
				return `${id} - ${this.assets.sd2000Tables[id].title}`;
			},
			getTextExam(id) {
				id = id.split('.');
				return `${id[1]} - ${
					this.assets.sd2000Tables[id[0]][id[1]].title
				}`;
			},
		},
		computed: {
			modelExams: {
				set(val) {
					this.$emit('input', val);
				},
				get() {
					return this.value;
				},
			},
			listExams() {
				let acc = [];
				for (let item in this.assets.sd2000Tables) {
					if (item != 'title') {
						let dItem = this.assets.sd2000Tables[item];
						for (let exam in dItem) {
							if (exam != 'title')
								acc.push({
									id: `${item}.${exam}`,
									label: `${exam}: ${dItem[exam].title}`,
								});
						}
					}
				}
				return acc;
			},
		},
	};
</script>
<style scoped>
	.bg-white {
		background: none;
		height: 300px;
		overflow: auto;
	}
</style>



// WEBPACK FOOTER //
// src/components/sd2000/solicitacoes/mdCreateSolicitation/components/exams.vue